import { useEffect, useState, memo } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@mui/material/TextField';
import {DebounceInput} from 'react-debounce-input';
import InputAdornment from '@mui/material/InputAdornment';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';


const SangerPrimerRowVol = memo((props) => {
    const data = props.data;
    const primerKey = props.primerKey;
    const updatePrimerMap = props.updatePrimerMap;
    const showAllErrors = props.showAllErrors;
    const submitShowError = props.submitShowError;
  
  return (
    <Grid item alignItems="stretch">
        <>
        {data.labPrimer ?<AllInclusiveIcon
        sx={{
            position: 'absolute',
            marginTop: 1,
            marginLeft: 2
        }}
        /> : <></>}
        <DebounceInput
            debounceTimeout={500}
            minLength={1}
            element={TextField}
        id="vol"
        placeholder={data.labPrimer ? "" : "Volume"}
        disabled={data.labPrimer}
        variant="outlined"
        sx={{'& .MuiInputBase-root': { height: 40, borderRadius: 0, width: 100}, '& legend': { display: 'none' },
        '& fieldset': { top: 0 }, }}
        InputProps={{ inputmode: 'numeric', pattern: '[0-9]*',
        endAdornment: <InputAdornment style={{size: 10, marginLeft: -11, marginRight: -10}} position="end">µl</InputAdornment>}}
        value={data.vol}
        onChange={async (e) => {
        var newTouched = [...data.touched];
        newTouched[1] = true;
        updatePrimerMap(primerKey, { vol: e.target.value, touched: newTouched});
        }}
        onBlur={(e) => {
        var newTouched = [...data.touched];
        newTouched[1] = true;
        updatePrimerMap(primerKey, { touched: newTouched});
        }}
        error={((data.touched[1] || submitShowError) && showAllErrors)}
    />
    </>
    </Grid>
    );
},
(prevProps, nextProps) => {
    return prevProps.id === nextProps.id && prevProps.data.vol === nextProps.data.vol;
});

export default SangerPrimerRowVol;